<template>
  <div>
    <div class="header-gnb hd-pooqzone">
      <h1 class="logo">
        <a @click.prevent="moveUrl('home')" href="#">
          <img src="../../../assets/images/wavvezone/logo.png" alt="wavve on logo" />
        </a>
      </h1>
      <ul class="gnb-left">
        <li>
          <a @click.prevent="moveUrl('home')" :class="isActive('home')">홈</a>
        </li>
        <li class="category-list-item" @focusin="focus()" @mouseenter.prevent="focus()" @mouseleave.prevent="blur()" >
          <span tabindex="0" data-gnb="category-menu">카테고리</span>
          <category-menu></category-menu>
          <category-menu-layer></category-menu-layer>
        </li>
        <li>
          <a @click.prevent="moveUrl('live')" href="#" :class="isActive('live')">LIVE</a>
        </li>
        <li v-if="isPlayyComic">
          <a href="https://playycomic.wavve.com">만화</a>
        </li>
      </ul>
      <ul class="gnb-right">
        <li>
          <button @click.prevent="showSearchPopup('popul')" class="btn-search">
            <span>검색하기</span>
          </button>
        </li>
      </ul>
    </div>

    <search-popup v-if="showSearchPop" id="searchPop" :closeSearchPopup="closeSearchPopup" :pageType="searchPageType" :isplayymovie="isplayymovie" />
  </div>
</template>

<script>
import SearchPopup from '@/components/search/SearchPopup'
import { setDisableScrolling } from '@/common/utils/common'
import cookie from '@/common/utils/cookie'
import { mapGetters } from 'vuex'
import CategoryMenu from '@/components/common/header/CategoryMenu'
import CategoryMenuLayer from '@/components/common/header/CategoryMenuLayer'

export default {
  components: {
    SearchPopup,
    CategoryMenu,
    CategoryMenuLayer
  },
  props: {
    isPlayycomic: {
      type: String,
      required: true
    },
    isplayymovie: {
      type: String,
      default: 'y'
    }
  },
  data () {
    return {
      isVod: false,
      isMovie: false,
      showSearchPop: false,
      searchPageType: 'popul',
      pooqzoneType: cookie.getPooqZoneType()
    }
  },
  methods: {
    showSearchPopup (type) {
      this.$events.$emit('setInputShow', false)
      if (typeof window.setInputShow === 'function') {
        window.setInputShow(false)
      }
      this.searchPageType = type
      this.showSearchPop = true
      setDisableScrolling(true) // 윈도우 스크롤 방지
    },
    closeSearchPopup () {
      this.showSearchPop = false
      setDisableScrolling(false) // 윈도우 스크롤 사용
    },
    moveUrl (gnb) {
      this.$router.push({ name: gnb })
    },
    isActive (menu) {
      return this.currentMenu === menu ? 'on' : ''
    },
    focus () {
      document.querySelector('.category-list-item').classList.add('on')
    },
    blur () {
      document.querySelector('.category-list-item').classList.remove('on')
    },
    keyup (e) {
      if (e.target.dataset.gnb !== 'category-menu') {
        document.querySelector('.category-list-item').classList.remove('on')
      }
    }
  },
  mounted () {
    document.addEventListener('keyup', this.keyup)
  },
  computed: {
    ...mapGetters(['currentMenu']),
    isPlayyComic () {
      return this.isPlayycomic === 'y' || this.isPlayycomic === 'Y'
    }
  },
  created () {
    // 이벤트 리스너 설정
    this.$events.$on('showSearchPopupTag', value => {
      this.showSearchPopup(value)
    })
  },
  beforeDestroy () {
    this.$events.$off('showSearchPopup')
    document.removeEventListener('keyup', this.keyup)
  }
}
</script>
